import { computed } from "vue";
import type { Product } from "@shopware-pwa/types";
import { getTranslatedProperty } from "@shopware-pwa/helpers-next";

export function useProductPreOrder(product: ComputedRef<Product>) {
  const isPreOrderProduct = computed(() => {
    return product.value?.extensions?.preOrderData?.isPreOrderProduct ?? false;
  });
  const productPreOrderDescription = computed(() => {
    return getTranslatedProperty(product.value?.extensions?.preOrderData, "description");
  });
  return { isPreOrderProduct, productPreOrderDescription };
}
